import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, watch} from "vue";
import {SelectRemoteFieldType} from "@/components/business/crud/interface/FieldType";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";
import {SelectRemoteSearch} from "@/components/business/crud/interface/SearchType";
import _ from "lodash";
import SelectRemoteMulti from "@/components/business/crud/common/SelectRemoteMulti.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectRemoteSearch',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const selectRemoteWidget: SelectRemoteFieldType = {
  name: "selectRemote",
  path: props.widget.path,
  labelFieldName: props.widget.labelFieldName,
  valueFieldName: props.widget.valueFieldName,
  multi: true,
}

const value = ref<{ value: string; label: string }[]>([]);

watch(() => data.value[props.propName], () => {
  if (data.value[props.propName]instanceof Array) {
    value.value = data.value[props.propName]
  } else {
    value.value = [];
  }
}, {immediate: true, deep: true})

watch(value, () => {
  if (value.value.length > 0) {
    _.set(data.value, [props.propName], value.value);
  } else {
    delete data.value[props.propName];
  }
}, {immediate: true, deep: true})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectRemoteMulti, {
    title: _ctx.info.title,
    widget: selectRemoteWidget,
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
  }, null, 8, ["title", "modelValue"]))
}
}

})